export const CATEGORY_URL = {
	article: '/news',
	event: '/events',
	vacancy: '/vacancy',
	questionAnswer: '/question-answer',
	album: '/media',
	document: '/documents',
};
